import React from 'react';
import styles from './SubscriptionCard.module.scss';
import COButton from '../COButton';
import { SubscriptionCardEnums } from 'enums/SubscriptionCardEnums';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';

const SubscriptionCard = () => {
  const navigate = useNavigate();

  const redirectToLogin = () => {
    navigate(AppRoutes.LOGIN_VIEW);
  };

  return (
    <div className={styles.cardContainer}>
      <h1>Account Created Successfully!</h1>
      <div className={styles.descriptionContainer}>
        <p>
          You will be contacted shortly to activate your account and can also
          reach us directly at developer@carbon-one.ca.
        </p>
        <p className="mt-5">
          Thank you for chossing CarbonOne as your trusted Carbon Inteliigence
          Partner!
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <COButton onClick={redirectToLogin}>
          {SubscriptionCardEnums.BUTTON_LABEL}
        </COButton>
      </div>
    </div>
  );
};

export default SubscriptionCard;
